<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-modal
        id="modal-lg"
        ref="infoModal"
        centered
        size="lg"
        title="Detalle de guia de despacho"
        @ok="waybill = null"
        @hide="waybill = null"
        ok-only
      >
        <div class="text-center">
          <b-spinner v-if="!waybill" label="Spinning"></b-spinner>
        </div>
        <report v-if="waybill" :waybill="waybill"></report>
      </b-modal>

      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Listado de guías de materiales</h1>
        </b-col>
        <b-col>
          <b-form>
            <b-row>
              <b-col>
                <label for="monthSelect">Mes</label>
                <b-form-select
                  id="monthSelect"
                  v-model="selected.month"
                  :plain="true"
                  :options="selectOptions.months"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
              <b-col>
                <label for="yearSelect">Año</label>
                <b-form-select
                  id="yearSelect"
                  v-model="selected.year"
                  :plain="true"
                  :options="selectOptions.years"
                  value="Seleccione..."
                >
                </b-form-select>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>

      <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref="table" id="dataTable">
        <template slot="afterFilter">
          <tr v-if="loading" class="VueTables__no-results">
            <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
          </tr>
        </template>
        <div slot="beforeLimit">
          <download-excel
            class="btn"
            :fetch="fetchData"
            :fields="json_fields"
            worksheet="Recepcion"
            :name="name"
            :before-generate="startDownload"
            :before-finish="finishDownload"
          >
            <b-button>Descargar</b-button>
          </download-excel>
        </div>
        <div slot="number" slot-scope="props">
          <div style="text-align: right">{{ props.row.number }}</div>
        </div>
        <div slot="waybill_date" slot-scope="props">
          <div style="text-align: right">{{ props.row.waybill_date }}</div>
        </div>
        <div slot="waybill_type" slot-scope="props">
          <div>{{ getWaybillType(props.row.waybill_type) }}</div>
        </div>
        <div class="text-right" slot="actions" slot-scope="props">
          <a
            target="_blank"
            href="#"
            @click.prevent="getCompleteWaybill(props.row.id)"
            class="fa fa-lg fa-search text-primary"
          ></a
          >&nbsp;
          <a
            target="_blank"
            href="#"
            @click.prevent="editWaybill(props.row)"
            class="fa fa-lg fa-edit text-primary"
            v-if="[3, 5].includes(props.row.waybill_type)"
          ></a>
          <!--            <a target="_blank" @click.prevent="deleteWaybill(props.row.id)" href="#" class="fa fa-lg fa-trash text-danger"></a>-->
          <a :href="props.row.dte_url" download target="_blank" v-if="props.row.dte_url">
            <i class="fa fa-lg fa-file-pdf-o text-danger"></i>
          </a>
        </div>
      </v-server-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import Report from "./Report";

numeral.locale("es");
window.axios = require("axios");

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

const waybillTypes = {
  0: "Recepcion fruta",
  1: "Despacho fruta",
  3: "Ingreso",
  4: "Despacho",
  5: "Movimiento",
  6: "Consumo"
};

export default {
  name: "List",
  components: {
    ServerTable,
    Report
  },
  created() {
    this.getProducts();
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
    this.loadYear();
  },
  data() {
    return {
      loading: false,
      waybill: null,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Exportadora: "client_customer.company_name",
        "Fecha Guia": "waybill_date",
        Numero: "number",
        Emisor: "company_name",
        Destinatario: "recipient_company.company_name",
        Chofer: "truck_driver",
        Patente: "license_plate",
        Nota: "note"
      },
      columns: [
        "client_customer.company_name",
        "waybill_type",
        "waybill_date",
        "number",
        "company.company_name",
        "recipient_company.company_name",
        "truck_driver",
        "license_plate",
        "note",
        "actions"
      ],
      selected: {
        waybill_type: "",
        month: d.getMonth() + 1,
        year: d.getFullYear()
      },
      selectOptions: {
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        waybill_types: [
          { value: "", text: "-------" },
          { value: 3, text: "Entrada" },
          { value: 4, text: "Salida" }
        ],
        years: []
      },
      data: [],
      productSet: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        debounce: 800,
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            results[key].waybill_date = moment(results[key].waybill_date).format("DD-MM-YYYY");
            results[key].total_kilograms = numeral(parseFloat(results[key].total_kilograms));
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        // columnsDropdown: true,
        filterByColumn: false,
        headings: {
          number: "Numero",
          "company.company_name": "Emisor",
          "recipient_company.company_name": "Destinatario",
          truck_driver: "Chofer",
          license_plate: "Pantente",
          note: "Nota",
          "client_customer.company_name": "Exportadora",
          waybill_date: "Fecha Guia",
          waybill_type: "Tipo",
          actions: "Acciones"
        },
        sortable: [],
        sortIcon: { base: "fa", up: "fa-sort-asc", down: "fa-sort-desc", is: "fa-sort" },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  watch: {
    selected: {
      handler(val) {
        this.getProductSet(this.selected.product);
      },
      deep: true
    }
  },
  computed: {
    name() {
      return "Guias Materiales " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },
    url() {
      return (
        "/supplies/supply-waybill/?omit=details&expand=recipient_company,company,client_customer" +
        "&arrival_month=" +
        this.selected.month +
        "&arrival_year=" +
        this.selected.year
      );
    }
  },
  methods: {
    async fetchData() {
      const response = await this.$axios.get(this.url + "&no_page");
      return response.data;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    getCompleteWaybill(a) {
      this.$refs.infoModal.show();
      this.$axios
        .get("/supplies/supply-waybill/" + a + "/?expand=company,client_customer,recipient_company")
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
    },
    getWaybillType(waybill_type) {
      return waybillTypes[waybill_type];
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          // console.log(res)
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.selectOptions.products = products;
        })
        .catch((error) => console.log(errors));
    },
    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.selectOptions.product_types = res.data.product_types;
        })
        .catch((error) => (this.selected.product_type = ""));
    },
    deleteWaybill(a) {
      this.$axios
        .delete("/api/v1/waybill/" + a + "/")
        .then((res) => {
          if (res.data.status == 1) {
            miniToastr.success("Guía eliminada con exito", "");
            this.$refs.table.refresh();
          }

          if (res.data.status == 2) {
            miniToastr.info("Imposible eliminar la guia, tiene contenidos procesados", "");
          }
        })
        .catch((error) => console.log(error));
    },
    editWaybill(waybill) {
      if (waybill.waybill_type == 3) {
        this.$router.push({
          name: "materiales-editar-ingreso",
          params: {
            id: waybill.id
          }
        });
      } else if (waybill.waybill_type == 4) {
        this.$router.push({
          name: "materiales-editar-despacho",
          params: {
            id: waybill.id
          }
        });
      } else {
        this.$router.push({
          name: "materiales-editar-movimiento",
          params: {
            id: waybill.id
          }
        });
      }
    },
    loadYear() {
      for (let ano = 2019; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    },
    downloadItem(url, label) {
      this.loading = true;
      this.$axios
        .get({ baseURL: url, responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error)
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
